import { defineSlotRecipe } from "@chakra-ui/react"
import { accordionAnatomy } from "@chakra-ui/react/anatomy"

const accordionRecipe = defineSlotRecipe({
  className: "hydrologiq-accordion",
  slots: accordionAnatomy.keys(),

  variants: {
    variant: {
      primary: {
        root: {
          base: {
            width: "100%",
          },
        },
        item: {
          _open: {
            // borderBottom: "1px solid #cbcbcb",
            pb: "15px",
          },
        },
        itemTrigger: {
          _hover: {
            cursor: "pointer",
          },
        },
        itemIndicator: {
          color: "primary",
          bg: "white",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "#39aed2",
          fontSize: "1em",

          "&> :where(svg)": {
            color: "#39aed2",
            height: "100%",

            // _hover: {
            //   color: "white",
            // },
            // "&:disabled": {
            //   color: "primary",
            // },
          },
          _hover: {
            bg: "#0bc5ea",
            color: "white",
            borderColor: "#0bc5ea",
            cursor: "pointer",

            "&> :where(svg)": {
              color: "white",
            },
          },
          "&:disabled": {
            bg: "#a9a9a9",
            borderColor: "#a9a9a9",
            color: "primary",
            cursor: "not-allowed",

            "&> :where(svg)": {
              color: "primary",
            },
          },
        },
      },
      secondary: {
        root: {
          base: {
            fontSize: "md",
            width: "100%",
          },
        },
        item: {
          border: "1px solid #545454",
          borderRadius: "5px",
          _open: {
            pb: "8px",
          },
        },
        itemContent: {
          padding: "12px",
        },
        itemTrigger: {
          padding: "12px",
          _hover: {
            cursor: "pointer",
          },
          _open: {
            borderRadius: "0px",
            borderBottom: "1px solid #545454",
          },
        },
        itemIndicator: {
          color: "primary",
          bg: "white",
          paddingInlineEnd: "1em",
          paddingInlineStart: "1em",
          height: "2.5em",
          borderRadius: "5px",
          border: "1.5px solid",
          borderColor: "#39aed2",
          fontSize: "1em",

          "&> :where(svg)": {
            color: "#39aed2",
            height: "100%",

            // _hover: {
            //   color: "white",
            // },
            // "&:disabled": {
            //   color: "primary",
            // },
          },
          _hover: {
            bg: "#0bc5ea",
            color: "white",
            borderColor: "#0bc5ea",
            cursor: "pointer",

            "&> :where(svg)": {
              color: "white",
            },
          },
          "&:disabled": {
            bg: "#a9a9a9",
            borderColor: "#a9a9a9",
            color: "primary",
            cursor: "not-allowed",

            "&> :where(svg)": {
              color: "primary",
            },
          },
        },
      },
    },
  },
})

export default accordionRecipe
